import { ChangeDetectorRef, Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-card-info-steps',
  templateUrl: './card-info-steps.component.html',
  styleUrls: ['./card-info-steps.component.scss']
})

export class CardInfoStepsComponent implements OnInit, OnChanges {
    
    @Input('color') color = '#5BA5FE'
    @Input('showChart') showChart = true
    @Input('compact') compact = false
    @Input('infoTitle') infoTitle = "Título"
    @Input('infoDescription') infoDescription = "Título"
    @Input('progressLabel') progressLabel = "Configuração"
    @Input('steps') steps!: any;

    get progressPercent(): number {
      const total = this.counts.trueCount + this.counts.falseCount;
      return total > 0 ? (this.counts.trueCount / total) * 100 : 0;
    }

    loading = false;
    colorScheme = {
      domain: [
        this.color,
        '#E4E6EF',
      ]
    }
  
    counts:any =  {
      trueCount: 0,
      falseCount: 0,
    }
  
    series = [
      {
        "name": "Concluído",
        "value": this.counts.trueCount,
      },
      {
        "name": "Pendente",
        "value": this.counts.falseCount,
      },
    ];
  
    constructor(
      private _changeDetector: ChangeDetectorRef,
    ) { }
  
    ngOnInit(): void {
        this.colorScheme = {
            domain: [
                this.color,
                '#E4E6EF',
            ]
        }
        this.updateCounts();
    }

    ngOnChanges(changes: SimpleChanges): void {
      if (changes['steps'] && this.steps) {
        this.updateCounts();
      }
    }
  
    updateCounts() {
      this.counts = Object.values(this.steps).reduce(
        (accumulator:any, currentValue:any) => {
            const asBool = currentValue === true || currentValue === 1 || currentValue === '1';
            accumulator[asBool ? 'trueCount' : 'falseCount']++;
            return accumulator;
          },
          { trueCount: 0, falseCount: 0 }
      );
      this.series = [
        {
          "name": "Concluído",
          "value": this.counts.trueCount,
        },
        {
          "name": "Pendente",
          "value": this.counts.falseCount,
        },
      ];
      this._changeDetector.detectChanges();
    }
  
  }
  
